import { ComponentRef } from '@wix/public-editor-platform-interfaces';
import { BaseSDKShape } from '../BaseSDKShape';
import { PlatformSDKShape } from '../PlatformSDKShape';
import {
  BindingTarget,
  IBindingConnectionItem,
  IDataBindingItem,
} from './types';
export class BindingConnectionItem {
  constructor(
    private privateAPI: any,
    private compRef: ComponentRef,
    private bindingTargetId: string,
    private config: string,
  ) {}

  public update(data: Partial<IDataBindingItem>) {
    return this.privateAPI.bindings.update(this.compRef, this.bindingTargetId, {
      config: data.config,
      role: data.role,
    });
  }

  public delete() {
    return this.privateAPI.bindings.delete(this.compRef, this.bindingTargetId);
  }

  get connectionConfig() {
    return this.config;
  }
}
export class BindingsSDKShape extends BaseSDKShape {
  public async get(
    bindingTarget: BindingTarget,
  ): Promise<IBindingConnectionItem | null> {
    const privateAPI = await this.getPlatformPrivateAPI();
    const compRefs = await privateAPI.components.getSelectedComponents();
    if (compRefs.length !== 1) {
      return null;
    }
    const [compRef] = compRefs;
    const dataBindingConfig = privateAPI.bindings.get(
      bindingTarget.id,
      compRef,
    );
    if (!dataBindingConfig) {
      return null;
    }

    return new BindingConnectionItem(
      privateAPI,
      compRef,
      bindingTarget.id,
      dataBindingConfig,
    );
  }
}

export default new PlatformSDKShape(BindingsSDKShape)
  .withPublicMethod('get')
  .build();
